import { Domain } from '@3nickels/data-modules';
import {
  LearnMoreAdviceAndThreeNickelsUDrawer,
  LearnMoreAdviceDrawer,
  LearnMoreFreeDrawer,
  LearnMoreGuidedChoiceDrawer,
} from '../../drawers';

interface PricebookOptionLearnMoreDrawerProps {
  pricebookBundle: Domain.PricebookBundle;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: any;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  freemiumPricebook?: boolean;
}

const PricebookOptionLearnMoreDrawer: React.FC<PricebookOptionLearnMoreDrawerProps> = ({
  pricebookBundle,
  metadata,
  drawerOpen,
  setDrawerOpen,
  freemiumPricebook,
}) => {
  const internalFreeTrial = pricebookBundle.pricebook.metadata?.internalFreeTrial === 'true';

  return pricebookBundle.pricebook.productType === Domain.PricebookProductTypeEnum.NICKELS ? (
    pricebookBundle.prices[0].price === 0 && !internalFreeTrial ? (
      <LearnMoreFreeDrawer
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        pricebookBundle={pricebookBundle}
        pricebookMetadata={metadata}
      />
    ) : (
      <LearnMoreAdviceDrawer
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        pricebookBundle={pricebookBundle}
        pricebookMetadata={metadata}
      />
    )
  ) : pricebookBundle.pricebook.productType === Domain.PricebookProductTypeEnum.NICKELSU ? (
    <LearnMoreAdviceAndThreeNickelsUDrawer
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
      pricebookBundle={pricebookBundle}
      pricebookMetadata={metadata}
      freemium={freemiumPricebook}
    />
  ) : pricebookBundle.pricebook.productType === Domain.PricebookProductTypeEnum.GUIDED_CHOICE ? (
    <LearnMoreGuidedChoiceDrawer
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
      pricebookBundle={pricebookBundle}
      pricebookMetadata={metadata}
    />
  ) : null;
};

export default PricebookOptionLearnMoreDrawer;
